import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// API instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token varsa header'a ekle
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API'leri
export const authAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (credentials) => api.post('/auth/login', credentials),
};

// Google Login API
export const googleLoginAPI = (userData) => api.post('/auth/google-login', userData);

// Şifre sıfırlama API'leri
export const forgotPasswordAPI = (data) => api.post('/password/forgot', data);
export const resetPasswordAPI = (data) => api.post('/password/reset', data);

export default api;